<template>
  <div class="marketplace-forgot-password">
    <h2>{{ 'Forgot password?' | t }}</h2>
    <p v-if="!success">{{ 'Please enter your email to reset your password.' | t }}</p>
    <div v-if="success" class="marketplace-forgot-password--success">
      <div class="icon-wrapper">
        <SloIcon name="EnvelopeCircleCheckSolid" size="lg" />
      </div>
      <p>
        {{ 'An email has been sent to you with information on how to reset your password.' | t }}
        <a href="/">{{ 'Click here' | t }}</a> {{ 'to return to the sloan.com homepage.' | t }}
      </p>
    </div>
    <form v-else action="#" v-stack-y:sm @submit.prevent="handleSubmit">
      <SloField>
        <SloLabel :error="error">{{ 'Email' | t }}</SloLabel>
        <SloInput
          :error="error"
          ref="input"
          v-model="email"
          name="email"
          type="email"
          inputmode="email"
          required
        />
      </SloField>
      <div class="button-wrapper mt-lg">
        <SloButton :to="{name: 'marketplace-auth-login'}" fill="outline">
          {{ 'Cancel' | t }}
        </SloButton>
        <SloButton type="submit" :disabled="!email || loading">
          <SloLoader :loading="loading" color="white" size="md">
            {{ 'Reset Password' | t }}
          </SloLoader>
        </SloButton>
      </div>
    </form>
  </div>
</template>

<script>
import t from '../../../js/main/i18n';
import {mapActions} from 'vuex';
import SloField from '../../../lib/components/SloField.vue';
import SloLabel from '../../../lib/components/SloLabel.vue';
import SloInput from '../../../lib/components/SloInput.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import SloLoader from '../../../lib/components/SloLoader.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloField,
    SloLabel,
    SloInput,
    SloButton,
    SloLoader,
    SloIcon
  },
  filters: {
    t
  },
  mounted() {
    this.$nextTick(() => this.$refs.input.setFocus());
  },
  data() {
    return {
      email: '',
      loading: false,
      error: null,
      success: false
    };
  },
  watch: {
    email() {
      this.error = null;
    }
  },
  methods: {
    ...mapActions('auth', ['forgotPassword']),
    async handleSubmit() {
      this.loading = true;

      await this.forgotPassword({email: this.email})
        .then(async() => {
          this.success = true;
          this.loading = false;
        })
        .catch(e => {
          this.success = false;
          this.loading = false;
          this.error = true;
          if (e?.response?.data?.errors) {
            const errors = e?.response?.data?.errors;
            this.emailError = errors.find(error => error?.subject === 'email')?.message;
            this.$snotify.error(t(errors[0]?.message));
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.marketplace-forgot-password {
  margin-block: 6.4rem;

  &--success {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.6rem;

    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 4.8rem;
      min-height: 4.8rem;
      background-color: $color-blue-50;
      border-radius: 9999px;
      color: $color-blue-400;
    }

    p {
      margin: 0;
    }
  }

  &--success, form {
    width: 100%;
    max-width: 410px;
    margin-block-start: 3.2rem;
    margin-inline: auto;
    padding: 1.6rem;
    border: 1px solid #d1d5db;
    border-radius: 1.2rem;

    @media (min-width: $screen-sm) {
      padding: 3.2rem;
    }
  }

  > h2, > p {
    text-align: center;
  }

  .button-wrapper {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    gap: 1.6rem;

    @media (min-width: $screen-sm) {
      gap: 3.2rem;
    }

    > * {
      flex: 1 1 50%;
      width: 100%;
    }

    .slo-button {
      width: 100%;
    }
  }
}
</style>
